import { STATIC_EXPERIMENTS } from './staticExperiments';
import { getPagePrefix } from './utils';

const pagesWithDuplicatedExperiments: { [page: string]: string[] } = {};

export const EXPERIMENT_CONFIG = STATIC_EXPERIMENTS.reduce(
  (experimentConfig: Record<string, string>, experiment, index) => {
    const prefix = getPagePrefix(experiment.pageType);
    const experimentPages =
      'slugs' in experiment && experiment.slugs
        ? experiment.slugs.map(slug => (slug ? `${prefix}/${slug}` : prefix))
        : [prefix];

    experimentPages.forEach(experimentPage => {
      // Searching for duplicated experiments
      const existingExperimentOnPage = experimentConfig[experimentPage];
      if (existingExperimentOnPage) {
        if (!pagesWithDuplicatedExperiments[experimentPage]) {
          pagesWithDuplicatedExperiments[experimentPage] = [existingExperimentOnPage];
        }
        pagesWithDuplicatedExperiments[experimentPage].push(experiment.name);
      }
      // End searching for duplicated experiments

      experimentConfig[experimentPage] = experiment.name;
    });

    // Forcing failure if more than one static experiment per page is found
    if (
      index === STATIC_EXPERIMENTS.length - 1 &&
      Object.keys(pagesWithDuplicatedExperiments).length > 0
    ) {
      const errorFriendlyObject = Object.keys(pagesWithDuplicatedExperiments).reduce(
        (acc: Record<string, string>, key) => {
          acc[key] = pagesWithDuplicatedExperiments[key].join(' | ');
          return acc;
        },
        {},
      );
      throw new Error('There can only be one static experiment per page', {
        cause: errorFriendlyObject,
      });
    }

    return experimentConfig;
  },
  {},
);
